module.exports = __webpack_public_path__ + "static/technika.a59280c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/technika.jpg
// module id = 705
// module chunks = 39862026607597